window._ = require('lodash')
window.toastr = require('toastr')
window.katex = require('katex')
window.moment = require('moment')
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import videojs from 'video.js'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { VTooltip } from 'v-tooltip'
import { createApp } from 'vue'

window.videojs = videojs
window.VueTimepicker = VueTimepicker

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.$ = window.jQuery = require('jquery')
} catch (e) {
}

const app = createApp({})

app.directive('tooltip', VTooltip)

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

app.component('v-select', vSelect)
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Quizzes
app.component('QuizImageUpload', require('./components/quiz/QuizImageUpload.vue').default)


// Quiz Creation
app.component('ChooseLocale', require('./components/quiz/QuizCorrection/ChooseLocale.vue').default)

app.component('IssueQuizLocaleCorrection', require('./components/quiz/QuizCorrection/IssueQuizLocaleCorrection.vue').default)

app.component('IssueQuizLocaleCorrectionQuestion', require('./components/quiz/QuizCorrection/IssueQuizLocaleCorrectionQuestion.vue').default)

app.component('QuizTranslationCorrection', require('./components/quiz/QuizCorrection/QuizTranslationCorrection.vue').default)

app.component('QuizEnglishMasterCorrection', require('./components/quiz/QuizCorrection/QuizEnglishMasterCorrection.vue').default)

app.component('QuizEnglishMasterCorrectionQuestion', require('./components/quiz/QuizCorrection/QuizEnglishMasterCorrectionQuestion.vue').default)

app.component('QuizEnglishMasterCorrectionOption', require('./components/quiz/QuizCorrection/QuizEnglishMasterCorrectionOption.vue').default)

app.component('QuizCreation', require('./components/quiz/QuizCreation/QuizCreation.vue').default)

app.component('QuizCreationQuestion', require('./components/quiz/QuizCreation/QuizCreationQuestion.vue').default)

app.component('QuizCreationOption', require('./components/quiz/QuizCreation/QuizCreationOption.vue').default)

app.component('QuizCreationProof', require('./components/quiz/QuizCreationProof/QuizCreationProof.vue').default)

app.component('QuizCreationProofQuestion', require('./components/quiz/QuizCreationProof/QuizCreationProofQuestion.vue').default)

app.component('QuizCreationProofOption', require('./components/quiz/QuizCreationProof/QuizCreationProofOption.vue').default)


// Quiz Translation
app.component('QuizTranslation', require('./components/quiz/QuizTranslation/QuizTranslation.vue').default)

app.component('QuizTranslationQuestion', require('./components/quiz/QuizTranslation/QuizTranslationQuestion.vue').default)

app.component('QuizTranslationOption', require('./components/quiz/QuizTranslation/QuizTranslationOption.vue').default)

app.component('QuizTranslationProof', require('./components/quiz/QuizTranslation/QuizTranslationProof.vue').default)

app.component('QuizTranslationProofQuestion', require('./components/quiz/QuizTranslation/QuizTranslationProofQuestion.vue').default)

app.component('QuizTranslationProofOption', require('./components/quiz/QuizTranslation/QuizTranslationProofOption.vue').default)


// Quiz Localization
app.component('QuizLocalization', require('./components/quiz/QuizLocalization/QuizLocalization.vue').default)

app.component('QuizLocalizationQuestion', require('./components/quiz/QuizLocalization/QuizLocalizationQuestion.vue').default)

app.component('QuizLocalizationOption', require('./components/quiz/QuizLocalization/QuizLocalizationOption.vue').default)


// Quiz Translated Localization
app.component('QuizTranslatedLocalization', require('./components/quiz/QuizTranslatedLocalization/QuizTranslatedLocalization.vue').default)

app.component('QuizTranslatedLocalizationQuestion', require('./components/quiz/QuizTranslatedLocalization/QuizTranslatedLocalizationQuestion.vue').default)

app.component('QuizTranslatedLocalizationOption', require('./components/quiz/QuizTranslatedLocalization/QuizTranslatedLocalizationOption.vue').default)


// Subtitles
app.component('SubtitleTranslation', require('./components/subtitles/SubtitleTranslation.vue').default)

app.component('SubtitleCueTextarea', require('./components/subtitles/SubtitleCueTextarea.vue').default)

app.component('SubtitleTranslatedLocalization', require('./components/subtitles/SubtitleTranslatedLocalization.vue').default)

app.component('SubtitleTranslatedLocalizationCue', require('./components/subtitles/SubtitleTranslatedLocalizationCue.vue').default)

app.component('SubtitleLocalization', require('./components/subtitles/SubtitleLocalization.vue').default)

app.component('SubtitleLocalizationCue', require('./components/subtitles/SubtitleLocalizationCue.vue').default)

app.component('SubtitleProofread', require('./components/subtitles/SubtitleProofread.vue').default)

app.component('SubtitleProofreadCue', require('./components/subtitles/SubtitleProofreadCue.vue').default)

app.component('subtitle-and-voice-correction', require('./components/subtitles/SubtitleAndVoiceCorrection.vue').default)

app.component('subtitle-correction', require('./components/subtitles/SubtitleCorrection.vue').default)

app.component('subtitle-correction-cue', require('./components/subtitles/SubtitleCorrectionCue.vue').default)

app.component('voice-correction', require('./components/voice/VoiceCorrection.vue').default)

app.component('subtitle-translation-correction', require('./components/subtitles/SubtitleTranslationCorrection.vue').default)

app.component('subtitle-translation-correction-cue', require('./components/subtitles/SubtitleTranslationCorrectionCue.vue').default)


// Video
app.component('videoproject-file', require('./components/VideoprojectFile.vue').default)

app.component('videoproject-correction', require('./components/VideoprojectCorrection.vue').default)


// Task Management
app.component('user-tasks', require('./components/tasks/UserTasks.vue').default)

app.component('running-tasks', require('./components/tasks/RunningTasks.vue').default)

app.component('completed-tasks', require('./components/tasks/CompletedTasks.vue').default)

app.component('assignable-task-list', require('./components/tasks/AssignableTaskList.vue').default)

app.component('assignable-task', require('./components/tasks/AssignableTask.vue').default)


app.component('task-box', require('./components/tasks/TaskBox.vue').default)

app.component('task-box-alt', require('./components/tasks/TaskBoxAlt.vue').default)


// Misc
app.component('submit-button', require('./components/SubmitButton.vue').default)


app.mount('#wrapper')

window.axios.defaults.headers.common['X-CSRF-TOKEN'] = window.csrfToken
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/*
 *
 *   INSPINIA - Responsive Admin Theme
 *   version 2.7
 *
 */

require('../vendor/bootstrap/js/bootstrap')
require('../vendor/metisMenu/jquery.metisMenu')
require('../vendor/slimscroll/jquery.slimscroll.min')
require('../vendor/pace/pace.min')
require('../vendor/toastr/toastr.min')
require('../vendor/jquery/plugins/flot/jquery.flot')
require('../vendor/jquery/plugins/flot/jquery.flot.tooltip.min')
require('../vendor/jquery/plugins/flot/jquery.flot.resize')
require('../vendor/jquery/plugins/flot/jquery.flot.pie')
require('../vendor/jquery/plugins/flot/jquery.flot.time')
require('../vendor/jquery/plugins/dataTables/datatables.min')
require('../vendor/jquery/plugins/datapicker/bootstrap-datepicker')
require('../vendor/jquery/plugins/diff_match_patch/javascript/diff_match_patch')
require('../vendor/jquery/plugins/preetyTextDiff/jquery.pretty-text-diff.min')

$(document).ready(function() {


    // Add body-small class if window less than 768px
    if ($(this).width() < 769) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }

    // MetsiMenu
    $('#side-menu').metisMenu()

    // Collapse ibox function
    $('.collapse-link').on('click', function() {
        var ibox = $(this).closest('div.ibox')
        var button = $(this).find('i')
        var content = ibox.children('.ibox-content')
        content.slideToggle(200)
        button.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
        ibox.toggleClass('').toggleClass('border-bottom')
        setTimeout(function() {
            ibox.resize()
            ibox.find('[id^=map-]').resize()
        }, 50)
    })

    // Close ibox function
    $('.close-link').on('click', function() {
        var content = $(this).closest('div.ibox')
        content.remove()
    })

    // Fullscreen ibox function
    $('.fullscreen-link').on('click', function() {
        var ibox = $(this).closest('div.ibox')
        var button = $(this).find('i')
        $('body').toggleClass('fullscreen-ibox-mode')
        button.toggleClass('fa-expand').toggleClass('fa-compress')
        ibox.toggleClass('fullscreen')
        setTimeout(function() {
            $(window).trigger('resize')
        }, 100)
    })

    // Minimalize menu
    $('.navbar-minimalize').on('click', function() {
        $('body').toggleClass('mini-navbar')
        SmoothlyMenu()

    })

    // Full height of sidebar
    function fix_height() {
        var heightWithoutNavbar = $('body > #wrapper').height() - 61
        $('.sidebard-panel').css('min-height', heightWithoutNavbar + 'px')

        var navbarHeight = $('nav.navbar-default').height()
        var wrapperHeigh = $('#page-wrapper').height()

        if (navbarHeight > wrapperHeigh) {
            $('#page-wrapper').css('min-height', navbarHeight + 'px')
        }

        if (navbarHeight < wrapperHeigh) {
            $('#page-wrapper').css('min-height', $(window).height() + 'px')
        }

        if ($('body').hasClass('fixed-nav')) {
            if (navbarHeight > wrapperHeigh) {
                $('#page-wrapper').css('min-height', navbarHeight + 'px')
            } else {
                $('#page-wrapper').css('min-height', $(window).height() - 60 + 'px')
            }
        }

    }

    fix_height()

    // Fixed Sidebar
    $(window).bind('load', function() {
        if ($('body').hasClass('fixed-sidebar')) {
            $('.sidebar-collapse').slimScroll({
                height: '100%',
                railOpacity: 0.9,
            })
        }
    })

    $(window).bind('load resize scroll', function() {
        if (!$('body').hasClass('body-small')) {
            fix_height()
        }
    })

    // Add slimscroll to element
    $('.full-height-scroll').slimscroll({
        height: '100%',
    })
})

// Minimalize menu when screen is less than 768px
$(window).bind('resize', function() {
    if ($(this).width() < 769) {
        $('body').addClass('body-small')
    } else {
        $('body').removeClass('body-small')
    }
})

function SmoothlyMenu() {
    if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
        // Hide menu in order to smoothly turn on when maximize menu
        $('#side-menu').hide()
        // For smoothly turn on menu
        setTimeout(
            function() {
                $('#side-menu').fadeIn(400)
            }, 200)
    } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide()
        setTimeout(
            function() {
                $('#side-menu').fadeIn(400)
            }, 100)
    } else {
        // Remove all inline style from jquery fadeIn function to reset menu state
        $('#side-menu').removeAttr('style')
    }
}
